import(/* webpackMode: "eager", webpackExports: ["default"] */ "/vercel/path0/src/app/client/(app)/quotes/QuotesInboxClient.tsx");
